import { z } from 'zod';
export const IdSchema = z.uuid();
export const TimestampSchema = z.iso.datetime({ offset: true });
export const DateOnlySchema = z.iso.date();
export const NonEmptyStringSchema = z.string().trim().min(1).max(255);
export const OptionalTextSchema = z.string().trim().max(10_000).nullable();
export const CurrencyCodeSchema = z.string().regex(/^[A-Z]{3}$/);
export const MoneyAmountSchema = z.string().regex(/^-?\d{1,15}(\.\d{1,2})?$/);
export const SortDirectionSchema = z.enum(['asc', 'desc']);
export const ListQuerySchema = z.strictObject({
    cursor: IdSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    q: z.string().trim().max(200).optional(),
    sortDirection: SortDirectionSchema.default('desc'),
});
export const PageInfoSchema = z.strictObject({
    nextCursor: IdSchema.nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
});
export const ProblemFieldSchema = z.strictObject({
    path: z.string(),
    message: z.string(),
});
export const ProblemSchema = z.strictObject({
    type: z.string().default('about:blank'),
    title: z.string(),
    status: z.number().int().min(400).max(599),
    code: z.string().regex(/^[a-z0-9_.-]+$/),
    detail: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string(),
    fields: z.array(ProblemFieldSchema).optional(),
});
export const MutationResultSchema = z.strictObject({
    id: IdSchema,
});
export const EntityMetadataSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
